import { useTripsTripSubscriptionExpiringSoonCountRetrieveQuery } from '@bambi/api-client/trips';

import { useUserRoles } from 'src/features/auth/useUserRoles';

export default function useTripSubscriptsExpiringSoonCount() {
  const { isRideOrderingPortalUser } = useUserRoles();
  const { data } = useTripsTripSubscriptionExpiringSoonCountRetrieveQuery(
    undefined,
    {
      skip: isRideOrderingPortalUser,
    }
  );

  return data?.count;
}
